import { render, staticRenderFns } from "./tips3.vue?vue&type=template&id=482c574b&scoped=true"
import script from "./tips3.vue?vue&type=script&lang=js"
export * from "./tips3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c574b",
  null
  
)

export default component.exports